/**
 * Enum representing the status of a task.
 */
export enum TasksStatusEnum {
  /** Task is new and has not been started. */
  Neu = 'new_task_status',
  /** Task is currently active and in progress. */
  Aktiv = 'active_task_status',
  /** Task is delayed and not on schedule. */
  Verzögert = 'delayed_task_status',
  /** Task has been resolved and completed. */
  Gelöst = 'resolved_task_status'
}

/**
 * Enum representing the type of a task.
 */
export enum TaskType {
  /** A one-time task. */
  einmalig = 1,
  /** A recurring task. */
  wiederkehrend = 2,
}

/**
 * Enum representing the name of a task type.
 */
export enum TaskTypeName {
  /** A normal task. */
  Normal = "normal",
  /** A follow-up task. */
  Nachverfolgen = "follow_up",
}

/**
 * Enum representing the repeated type of a task.
 */
export enum RepeatedType {
  /** A weekly recurring task. */
  wöchentlich = 4,
  /** A monthly recurring task. */
  monatlich = 5,
  /** A bi-weekly recurring task. */
  zweiwöchentlich = 18,
  /** A quarterly recurring task. */
  quartalsweise = 19,
  /** A semi-annual recurring task. */
  semester = 20,
  /** An annual recurring task. */
  jährlich = 21,
}
